<template lang="html">

  <section class="hablan-de-nosotros" >

    <h2 class="title">{{$t('clientes.slideTitle')}}</h2>
    <section class="articles-relacionated">
      <div class="all-entries">
        <last-noticias :success="1" ></last-noticias>
      </div>
    </section>
    <!-- <div class="contenedor-slider container-xs">
   
      <slick ref="slick" :options="slickOptions">

        <div class="slide" v-for="comentario in comentarios">

          <h4>{{comentario.titulo}}</h4>
          <p>{{comentario.texto}}</p>
          <h5>{{comentario.quien}}</h5>

        </div>

      </slick>

    </div> -->


  </section>

</template>

<script lang="js">

  import Slick from 'vue-slick';
  import lastNoticias from "@/components/views/ultimas-noticias-blog.vue";
  import moment from "moment";
  import editorjs from "@/components/views/editorjs";

  export default  {
    name: 'hablan-de-nosotros',
    props: ['comentarios'],
    data() {
      return {
        slickOptions: {
          slidesToShow: 1,
          arrows : true
        },
      }
    },
    components: { Slick,
    "last-noticias": lastNoticias },
  }
</script>

<style scoped >
.hablan-de-nosotros {
  background: rgba(51,116,176, 0.2);
  padding: 100px 0 1px 0;
}

.casos-de-exito .hablan-de-nosotros{
  padding-top: 150px;
}

.title{
  color: #41566d;
  margin-bottom: 30px;
}

h4{
  color: #41566d;
  font-size: 20px;
  line-height: 28px;
  width: 100%;
  font-weight: 600;
  margin-bottom: 5px;
  
}

p{
  color: #41566d;
  font-size: 18px;
  line-height: 28px;
  width: 100%;
}

h5{
  color: #41566d;
  font-size: 14px;
  line-height: 28px;
  width: 100%;
  font-weight: 600;
  margin-top: 5px;
}

@media screen and (max-width:768px){
  .hablan-de-nosotros{
    padding: 50px 0 70px 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/view-parts/clientes/hablan-de-nosotros.vue